import { environment } from "../../environment";

const baseURL = environment.react_app_url;
const clientContext = environment.react_app_client_context;

export const getLoggedInUserInfo = () => {
  return baseURL + `${clientContext}/v1/masterdata/user/getUserInfo`;
};
